import { useMap } from 'react-map-gl/maplibre'
import { useMediaQuery, useTheme, ZoomControl as View } from 'ui-components'

export const ZoomControl = () => {
  const { default: map } = useMap()
  const theme = useTheme()
  const hideZoom = useMediaQuery(theme.breakpoints.down(1280))

  const onZoomOut = () => {
    if (map) {
      map.zoomOut()
    }
  }

  const onZoomIn = () => {
    if (map) {
      map.zoomIn()
    }
  }

  if (hideZoom) return null

  return (
    <View
      onZoomOut={onZoomOut}
      onZoomIn={onZoomIn}
    />
  )
}
